import { Component, OnInit, OnDestroy } from "@angular/core";
import * as $ from "jquery";
import { CentralService } from "../servicios/central.service";
import {
  faSignInAlt,
  faKey,
  faEuroSign,
  faTractor,
  faMoneyBill,
  faFileInvoice,
  faUndo,
  faPrint,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { AvisosComponent } from "../avisos/avisos.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { Router } from "@angular/router";
import jsPDF from "jspdf";
import "jspdf-autotable";

@Component({
  selector: "app-liquidalis",
  templateUrl: "./liquidalis.component.html",
  styleUrls: ["./liquidalis.component.css"],
})
export class LiquidalisComponent implements OnInit, OnDestroy {
  dtOptions: any;
  dtTrigger: Subject<any> = new Subject();
  datosTabla: any = [{}];
  expandedIndex: number | null = null;

  icoEntr = faSignInAlt;
  icoKey = faKey;
  icoEur = faEuroSign;
  icoTra = faTractor;
  icoMny = faMoneyBill;
  icoInv = faFileInvoice;
  icoRet = faUndo;
  icoPrn = faPrint;
  icoFac = faFileAlt;

  fecdia: string;
  nomusu: string;
  menu: any;
  iconos = [
    this.icoKey,
    this.icoEur,
    this.icoTra,
    this.icoMny,
    this.icoInv,
    this.icoFac,
  ];

  resul: boolean;

  modoLis = 0;
  prifec: string;
  ultfec: string;

  constructor(
    private srvCentral: CentralService,
    private modalService: NgbModal,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.fecdia = Date().toLocaleString();
    this.nomusu = this.srvCentral.datosIden.UsuNom;

    /* Cargo tabla de menús */
    if (this.srvCentral.datosIden.UsuUsu !== "") {
      const k = this.srvCentral.listaMnu.length;
      this.menu = [];
      for (let i = 0; i < k; i++) {
        this.menu.push({
          nombre: this.srvCentral.listaMnu[i].nombre,
          ruta: this.srvCentral.listaMnu[i].ruta,
          icono: this.iconos[this.srvCentral.listaMnu[i].ico],
        });
      }
    }

    this.modoLis = this.srvCentral.EntModoLis;
    this.prifec = this.srvCentral.fechaCadena(this.srvCentral.gnPriDia);
    this.ultfec = this.srvCentral.fechaCadena(this.srvCentral.gnUltDia);
    this.cargaTabla();
  }

  toggleCard(i: number) {
    if (this.expandedIndex === i) {
      this.expandedIndex = null;
    } else {
      this.expandedIndex = i;
    }
  }

  ngOnDestroy(): void {
    // NO OLVIDAR DESUSCRIBIR EL EVENTO
    this.dtTrigger.unsubscribe();
  }
  persiana() {
    $("#wrapper").toggleClass("toggled");
  }

  cargaTabla(): void {
    this.dtOptions = {
      dom: "Blfrtip",
      buttons: [],
      ordering: false,
      responsive: true,
      language: {
        thousands: ".",
        decimal: ",",
        emptyTable: "No hay datos disponibles en la tabla",
        info: "Mostrando de _START_ a _END_ de _TOTAL_ registros",
        infoEmpty: "Mostrando de 0 a 0 de 0 registros",
        infoFiltered: "(filtrado de _MAX_ registros totales)",
        infoPostFix: "",
        lengthMenu: "Mostrar _MENU_ registros",
        loadingRecords: "Cargando...",
        processing: "Procesando...",
        search: "Buscar:",
        zeroRecords: "No se encontraron registros coincidentes",
        paginate: {
          first: "Primero",
          last: "Último",
          next: "Siguiente",
          previous: "Anterior",
        },
        aria: {
          sortAscending: ": activar para ordenar por columna ascendente",
          sortDescending: ": activar para ordenar por columna descendente",
        },
      },
    };
    this.cargaDatos();
  }

  cargaDatos() {
    this.resul = true;
    this.datosTabla = [];
    this.srvCentral
      .consulLiquida(this.modoLis, this.prifec, this.ultfec)
      .subscribe((datos) => {
        //console.log(datos);
        if (datos[0].liqFech === "?") {
          this.resul = false;
          const modalRef = this.modalService.open(AvisosComponent);
          modalRef.componentInstance.datAviso = {
            tit: "ERROR SERVIDOR",
            tex: datos[0].liqErro,
            tip: 2,
            btcan: "",
            btno: "",
            btsi: "Aceptar",
          };
          modalRef.result.then((result) => {});
        } else {
          if (datos[0].liqFech === "Sin Datos") {
            this.resul = false;
            const modalRef = this.modalService.open(AvisosComponent);
            modalRef.componentInstance.datAviso = {
              tit: "No hay datos disponibles",
              tex: datos[0].liqErro,
              tip: 2,
              btcan: "",
              btno: "",
              btsi: "Aceptar",
            };
            modalRef.result.then((result) => {});
          } else {
            this.resul = false;
            this.datosTabla = [];
            for (const datitem of datos) {
              this.datosTabla.push(datitem);
            }
          }
          this.dtTrigger.next();
        }
      });
  }

  volver(): void {
    this.router.navigate(["/liquida"]);
  }

  documento(i: number): void {
    console.log("Generando PDF para liquidación:", this.datosTabla[i]);
    this.resul = true;

    const ejer = this.datosTabla[i].ttEjer;
    const numliq = this.datosTabla[i].ttLiqu;

    this.srvCentral.pdfLiquidacion(ejer, numliq).subscribe(
      (response) => {
        this.resul = false;

        if (!response.Swresul) {
          const modalRef = this.modalService.open(AvisosComponent);
          modalRef.componentInstance.datAviso = {
            tit: "ERROR",
            tex: response.Txresul || "Error al obtener datos de la liquidación",
            tip: 2,
            btcan: "",
            btno: "",
            btsi: "Aceptar",
          };
          return;
        }

        const liquidaciones = response.liquidaciones?.ttLiquidacion || [];
        const partidas = response.partidas?.ttPartida || [];
        const conceptos = response.conceptos?.ttConcepto || [];

        if (liquidaciones.length === 0) {
          const modalRef = this.modalService.open(AvisosComponent);
          modalRef.componentInstance.datAviso = {
            tit: "Sin Datos",
            tex: "No se encontraron datos para esta liquidación",
            tip: 2,
            btcan: "",
            btno: "",
            btsi: "Aceptar",
          };
          return;
        }

        // Generar el PDF
        this.generarPDFLiquidacion(liquidaciones[0], partidas, conceptos);
      },
      (error) => {
        this.resul = false;
        console.error("Error al obtener liquidación:", error);
        const modalRef = this.modalService.open(AvisosComponent);
        modalRef.componentInstance.datAviso = {
          tit: "ERROR SERVIDOR",
          tex: "Error al comunicarse con el servidor",
          tip: 2,
          btcan: "",
          btno: "",
          btsi: "Aceptar",
        };
      },
    );
  }
  /*
  exportarPDF(dato: any) {
    const doc = new jsPDF();

    // 🔹 Encabezado
    doc.setFontSize(18);
    doc.setTextColor(26, 60, 110);
    doc.text("LIQUIDACIÓN", 14, 20);

    // 🔹 Datos del cliente y liquidación
    doc.setFontSize(12);
    doc.setTextColor(33, 33, 33);
    doc.text(`Cliente: ${this.srvCentral.datosIden.UsuNom || "---"}`, 14, 30);
    doc.text(`Fecha: ${dato.ttFech}`, 14, 37);
    doc.text(`Liquidación Nº: ${dato.ttLiqu}`, 14, 44);
    doc.text(`Serie: ${dato.ttSerie}`, 14, 51);

    doc.setLineWidth(0.5);
    doc.line(14, 55, 196, 55); // separador

    const startY = 60;
    const spacing = 8;

    doc.text("Concepto", 14, startY);
    doc.text("Importe (€)", 150, startY);

    const conceptos = [
      { label: "Compra", value: dato.ttCompra },
      { label: "Cargos", value: dato.ttCargos },
      { label: "Descuentos", value: dato.ttDtos },
      { label: "APA", value: dato.ttApa },
      { label: "Anticipos", value: dato.ttAntici },
      { label: "Base IVA", value: dato.ttBasiva },
      { label: "IVA", value: dato.CuoIva },
      { label: "Base Retención", value: dato.ttBasRet },
      { label: "Retención", value: dato.ttRetem },
      { label: "Imp. Retención", value: dato.ttImpRet },
      { label: "Bonificación", value: dato.ttBonif },
      { label: "Neto", value: dato.ttNeto },
    ];

    let y = startY + spacing;

    conceptos.forEach((c) => {
      doc.text(c.label, 14, y);
      doc.text(c.value?.toFixed(2) || "0.00", 150, y, { align: "right" });
      y += spacing;
    });

    // 🔹 Total
    doc.setFontSize(14);
    doc.setTextColor(26, 60, 110);
    doc.text("TOTAL", 14, y + 5);
    doc.text(dato.ttTotal?.toFixed(2) || "0.00", 150, y + 5, {
      align: "right",
    });

    // 🔹 Guardar PDF
    doc.save(`liquidacion_${dato.ttLiqu}_${dato.ttSerie}.pdf`);
  }
*/
  generarPDFLiquidacion(
    liquidacion: any,
    partidas: any[],
    conceptos: any[],
  ): void {
    /*
    console.log("Iniciando generación de PDF");
    console.log("Liquidación:", liquidacion);
    console.log("Partidas:", partidas);
    console.log("Conceptos:", conceptos);
    */

    const doc = new jsPDF();
    let yPos = 20;
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 14;
    const contentWidth = pageWidth - margin * 2;

    // ========== ENCABEZADO - Empresa ==========
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    const empresa = "Alanser Sociedad Cooperativa Ltda.";
    const cif = "F06026306";
    doc.text(empresa, margin, yPos);
    doc.text(cif, pageWidth - margin, yPos, { align: "right" });
    yPos += 8;

    // Título del documento
    doc.setFontSize(14);
    const titulo = "LIQUIDACIÓN DE PARTIDAS";
    doc.text(titulo, pageWidth / 2, yPos, { align: "center" });
    yPos += 10;

    // ========== DATOS DEL SOCIO ==========
    /*
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    // Formato: "SOCIO: 30 NOMBRE COMPLETO"
    doc.text(
      `SOCIO: ${liquidacion.CliCodig || ""} ${liquidacion.CliNombre || ""}`,
      margin,
      yPos,
    );
    yPos += 5;

    doc.text(`C.I.F.: ${liquidacion.CliCif || ""}`, margin, yPos);
    yPos += 5;

    doc.text(`DIRECCION: ${liquidacion.CliDireccion || ""}`, margin, yPos);
    yPos += 5;

    doc.text(
      `POBLACION: ${liquidacion.CliCodPostal || ""} ${liquidacion.CliPoblacion || ""}`,
      margin,
      yPos,
    );
    yPos += 5;

    doc.text(`PROVINCIA: ${liquidacion.CliProvincia || ""}`, margin, yPos);
    yPos += 5;

    doc.text(`TELEFONOS: ${liquidacion.CliTelefono || ""}`, margin, yPos);
    yPos += 5;

    // Formato banco: "BANCO: NOMBRE_BANCO C/c IBAN"
    const banco = liquidacion.CliBanco || "";
    const iban = liquidacion.CliIban || "";
    doc.text(`BANCO: ${banco} C/c ${iban}`, margin, yPos);
    yPos += 8;
    */

    // Dibujar el rectángulo para datos del socio
    doc.setDrawColor(0);
    doc.setLineWidth(0.3);
    const alturaDatosSocio = 37; // Altura del cuadro (7 líneas x 5 + padding)
    doc.rect(margin, yPos, contentWidth, alturaDatosSocio);

    // Escribir los textos dentro
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    const inicioY = yPos;
    yPos += 4; // Padding superior

    doc.text(
      `SOCIO: ${liquidacion.CliCodig || ""} ${liquidacion.CliNombre || ""}`,
      margin + 2,
      yPos,
    );
    yPos += 5;

    doc.text(`C.I.F.: ${liquidacion.CliCif || ""}`, margin + 2, yPos);
    yPos += 5;

    doc.text(`DIRECCION: ${liquidacion.CliDireccion || ""}`, margin + 2, yPos);
    yPos += 5;

    doc.text(
      `POBLACION: ${liquidacion.CliCodPostal || ""} ${liquidacion.CliPoblacion || ""}`,
      margin + 2,
      yPos,
    );
    yPos += 5;

    doc.text(`PROVINCIA: ${liquidacion.CliProvincia || ""}`, margin + 2, yPos);
    yPos += 5;

    doc.text(`TELEFONOS: ${liquidacion.CliTelefono || ""}`, margin + 2, yPos);
    yPos += 5;

    const banco = liquidacion.CliBanco || "";
    const iban = liquidacion.CliIban || "";
    doc.text(`BANCO: ${banco} C/c ${iban}`, margin + 2, yPos);

    yPos = inicioY + alturaDatosSocio + 5; // Posicionar después del cuadro

    // ========== DATOS DE LA FACTURA ==========
    doc.setFont("helvetica", "bold");
    const fechaLiq = this.formatearFecha(liquidacion.LiqFecFac);
    doc.text(
      `FACTURA: ${liquidacion.LiqSerie} ${liquidacion.LiqNumer}       FECHA LIQUIDACION: ${fechaLiq}`,
      pageWidth / 2,
      yPos,
      { align: "center" },
    );
    yPos += 10;

    // ========== PARTIDAS ==========
    const partidasLiq = partidas.filter(
      (p) => p.LiqNumer === liquidacion.LiqNumer,
    );

    partidasLiq.forEach((partida, index) => {
      // Verificar si necesitamos nueva página
      if (yPos > 240) {
        doc.addPage();
        yPos = 20;
      }

      // ========== CABECERA DE PARTIDA ==========
      /*
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      const fechaPar = this.formatearFecha(partida.ParFecha);

      // Línea 1: PARTIDA, FECHA PARTIDA, SEMANA
      const lineaPartida = `PARTIDA: ${partida.ParNumer}     FECHA PARTIDA: ${fechaPar}     SEMANA: ${partida.Ejecodig_Liq}/${partida.SemCodigo_Liq}     SEMANA: ${partida.Ejecodig_Liq}/${partida.SemCodigo_Liq}`;
      doc.text(lineaPartida, margin, yPos);
      yPos += 6;

      // Línea 2: Descripción del producto
      const descripcion = partida.ParDescri || "";
      doc.text(descripcion, margin, yPos);
      yPos += 7;
      */

      const fechaPar = this.formatearFecha(partida.ParFecha);
      const descripcion = partida.ParDescri || "";

      // Dibujar el rectángulo
      doc.setDrawColor(0);
      doc.setLineWidth(0.3);
      const alturaTotal = 12; // Altura del cuadro
      doc.rect(margin, yPos, contentWidth, alturaTotal);

      // Escribir los textos dentro
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      doc.text(
        `PARTIDA: ${partida.ParNumer}     FECHA PARTIDA: ${fechaPar}     SEMANA: ${partida.Ejecodig_Liq}/${partida.SemCodigo_Liq}     SEMANA: ${partida.Ejecodig_Liq}/${partida.SemCodigo_Liq}`,
        margin + 2,
        yPos + 4,
      );
      doc.text(descripcion, margin + 2, yPos + 9);

      yPos += alturaTotal + 3;

      // ========== TABLA DE DATOS DE LA PARTIDA ==========
      const unidad = partida.EsKilos ? "K" : "L";
      const peso = partida.EsKilos ? partida.ParKilos : partida.ParLibras;
      const pesoLiquidar = partida.EsKilos
        ? partida.ParKilosLiquidar
        : partida.ParLibrasLiquidar;
      const dto = partida.ParDto || 0;
      const precioResultante =
        partida.ParPrecio - (partida.ParPrecio * partida.ParComision) / 100;

      // Headers de la tabla
      const headers = [
        "Cantidad",
        "Peso Bruto",
        "Dto.",
        "Total Peso",
        "Precio",
        "Comisión",
        "Precio Resul.",
        "Media",
        "Media F.",
        "Correctivo",
        "Precio Final",
      ];

      // Datos de la tabla
      const datosTabla = [
        this.formatNum(partida.ParCantidad, 2),
        `${this.formatNum(peso, 2)} ${unidad}`,
        this.formatNum(dto, 2),
        this.formatNum(pesoLiquidar, 2),
        this.formatNum(partida.ParPrecio, 4),
        this.formatNum(partida.ParComision, 2),
        this.formatNum(precioResultante, 4),
        this.formatNum(partida.ParMedia, 2),
        this.formatNum(partida.ParMediaFija, 2),
        this.formatNum(partida.ParCorrect, 4),
        this.formatNum(partida.ParPrecioFinal, 4),
      ];

      (doc as any).autoTable({
        startY: yPos,
        head: [headers],
        body: [datosTabla],
        theme: "plain",
        styles: {
          fontSize: 8,
          cellPadding: 1,
          lineColor: [0, 0, 0],
          lineWidth: 0.1,
        },
        headStyles: {
          fontStyle: "bold",
          halign: "center",
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
        },
        bodyStyles: {
          halign: "right",
        },
        margin: { left: margin },
        tableWidth: contentWidth,
      });

      yPos = (doc as any).lastAutoTable.finalY + 8;

      // ========== CONCEPTOS DE LA PARTIDA ==========
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");

      // Encabezado de conceptos (con espaciado)
      doc.text("Cantidad", margin + 5, yPos);
      doc.text("Concepto", margin + 30, yPos);
      doc.text("Precio", pageWidth - margin - 50, yPos);
      doc.text("Importe", pageWidth - margin - 15, yPos);
      yPos += 5;

      // Línea principal del importe
      const textoKilosLibras = partida.EsKilos ? "Kilos" : "Libras";
      doc.text(this.formatNum(pesoLiquidar, 2), margin + 5, yPos);
      doc.text(`a`, margin + 30, yPos);
      doc.text(
        this.formatNum(partida.ParPrecioFinal, 4),
        pageWidth - margin - 50,
        yPos,
      );
      doc.text(
        this.formatNum(partida.ParImporte, 2),
        pageWidth - margin - 5,
        yPos,
        { align: "right" },
      );
      yPos += 5;

      // Conceptos adicionales (cargos/descuentos)
      const conceptosPar = conceptos.filter(
        (c) =>
          c.LiqNumer === liquidacion.LiqNumer &&
          c.ParNumer === partida.ParNumer,
      );

      conceptosPar.forEach((concepto) => {
        console.log("Añadiendo concepto:", concepto);
        const importeConcepto =
          concepto.Clase === 0 ? concepto.Importe * -1 : concepto.Importe;
        doc.text(this.formatNum(concepto.Cantidad, 2), margin + 5, yPos);
        doc.text(concepto.Concepto, margin + 30, yPos);
        doc.text(
          this.formatNum(concepto.Precio, 4),
          pageWidth - margin - 50,
          yPos,
        );
        doc.text(
          this.formatNum(importeConcepto, 2),
          pageWidth - margin - 5,
          yPos,
          { align: "right" },
        );
        yPos += 5;
      });

      // ========== SUBTOTALES DE LA PARTIDA ==========
      yPos += 2;

      // Subtotal Partida
      const anchoColumna = 50;
      doc.text(
        "Subtotal Partida",
        pageWidth - margin - anchoColumna - 35,
        yPos,
      );
      doc.text(
        this.formatNum(partida.ParSobre, 2),
        pageWidth - margin - 5,
        yPos,
        { align: "right" },
      );
      yPos += 5;

      // I.V.A.
      doc.text(
        `I.V.A. ${this.formatNum(partida.ParIVA, 2)}% Sobre ${this.formatNum(partida.ParBases, 2)}`,
        pageWidth - margin - anchoColumna - 35,
        yPos,
      );
      doc.text(
        this.formatNum(partida.Parcuiva, 2),
        pageWidth - margin - 5,
        yPos,
        { align: "right" },
      );
      yPos += 5;

      // Total Partida (con línea)
      doc.setLineWidth(0.3);
      doc.line(
        pageWidth - margin - anchoColumna,
        yPos,
        pageWidth - margin,
        yPos,
      );
      yPos += 5;

      doc.setFont("helvetica", "bold");
      doc.text("Total Partida", pageWidth - margin - anchoColumna - 35, yPos);
      doc.text(
        this.formatNum(partida.ParNeto, 2),
        pageWidth - margin - 5,
        yPos,
        { align: "right" },
      );
      yPos += 5;

      // Retención
      doc.setFont("helvetica", "normal");
      if (partida.ParReten !== 0) {
        doc.text(
          `Reten. ${this.formatNum(partida.ParReten, 2)}% Sobre ${this.formatNum(partida.ParBasReten, 2)}`,
          pageWidth - margin - anchoColumna - 35,
          yPos,
        );
        doc.text(
          this.formatNum(partida.ParImpReten * -1, 2),
          pageWidth - margin - 5,
          yPos,
          { align: "right" },
        );
        yPos += 5;
      }

      // Neto Partida (con línea)
      doc.line(
        pageWidth - margin - anchoColumna,
        yPos,
        pageWidth - margin,
        yPos,
      );
      yPos += 5;

      doc.setFont("helvetica", "bold");
      const netoPartida =
        partida.ParNeto - partida.ParImpReten - (partida.ParImporBonif || 0);
      doc.text("NETO PARTIDA", pageWidth - margin - anchoColumna - 35, yPos);
      doc.text(this.formatNum(netoPartida, 2), pageWidth - margin - 5, yPos, {
        align: "right",
      });
      yPos += 5;

      // Base Anticipo
      doc.setFont("helvetica", "normal");
      if (partida.ParPagado && partida.ParPagado !== 0) {
        doc.text(
          "Base Anticipo (A descontar de base partida)",
          pageWidth - margin - anchoColumna - 35,
          yPos,
        );
        doc.text(
          this.formatNum(partida.ParPagado, 2),
          pageWidth - margin - 5,
          yPos,
          { align: "right" },
        );
        yPos += 5;
      }

      // Guías
      if (partida.Guias) {
        yPos += 2;
        doc.text(`Guías: ${partida.Guias}`, margin, yPos);
        yPos += 5;
      }

      // Observaciones
      if (partida.Observaciones) {
        doc.text(`Observaciones: ${partida.Observaciones}`, margin, yPos);
        yPos += 5;
      }

      yPos += 8;
      doc.setFont("helvetica", "normal");

      // Línea separadora entre partidas (excepto la última)
      if (index < partidasLiq.length - 1) {
        doc.setLineWidth(0.1);
        doc.line(margin, yPos, pageWidth - margin, yPos);
        yPos += 10;
      }
    });

    // ========== RESUMEN FINAL ==========
    if (yPos > 200) {
      doc.addPage();
      yPos = 20;
    }

    yPos += 5;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);

    doc.text("RESUMEN FACTURA", margin, yPos);
    yPos += 8;
    /*
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);

    const anchoResumen = 50;

    // Número de partidas (solo si hay más de 1)
    if (liquidacion.NumPartidas > 1 || partidasLiq.length > 1) {
      doc.text("Número de partidas", margin, yPos);
      doc.text(
        String(liquidacion.NumPartidas || partidasLiq.length),
        pageWidth - margin - 5,
        yPos,
        { align: "right" },
      );
      yPos += 5;
    }

    // Subtotal liquidación
    doc.text("Subtotal liquidación", margin, yPos);
    doc.text(
      this.formatNum(liquidacion.LiqCompra, 2),
      pageWidth - margin - 5,
      yPos,
      { align: "right" },
    );
    yPos += 5;

    // Importe cargos
    doc.text("Importe cargos", margin, yPos);
    doc.text(
      this.formatNum(liquidacion.LiqImpCar, 2),
      pageWidth - margin - 5,
      yPos,
      { align: "right" },
    );
    yPos += 5;

    // Importe descuentos
    doc.text("Importe descuentos", margin, yPos);
    doc.text(
      this.formatNum(liquidacion.LiqImpDto * -1, 2),
      pageWidth - margin - 5,
      yPos,
      { align: "right" },
    );
    yPos += 5;

    // Importe A.P.A.
    doc.text("Importe A.P.A.", margin, yPos);
    doc.text(
      this.formatNum(liquidacion.LiqImpRappel * -1, 2),
      pageWidth - margin - 5,
      yPos,
      { align: "right" },
    );
    yPos += 5;

    // Anticipos (solo si existe)
    if (liquidacion.LiqPagado && liquidacion.LiqPagado !== 0) {
      doc.text("Importe anticipos", margin, yPos);
      doc.text(
        this.formatNum(liquidacion.LiqPagado * -1, 2),
        pageWidth - margin - 5,
        yPos,
        { align: "right" },
      );
      yPos += 5;
    }

    // IVAs
    for (let i = 1; i <= 5; i++) {
      const base = liquidacion[`LiqBases${i}`];
      const iva = liquidacion[`LiqIVA${i}`];
      const cuota = liquidacion[`LiqCuiva${i}`];

      if (base && base !== 0) {
        doc.text(
          `I.V.A. ${this.formatNum(iva, 2)} % Sobre ${this.formatNum(base, 2)}`,
          margin,
          yPos,
        );
        doc.text(this.formatNum(cuota, 2), pageWidth - margin - 5, yPos, {
          align: "right",
        });
        yPos += 5;
      }
    }

    // Línea antes del total
    doc.setLineWidth(0.3);
    doc.line(pageWidth - margin - anchoResumen, yPos, pageWidth - margin, yPos);
    yPos += 5;

    // Total liquidación
    doc.setFont("helvetica", "bold");
    doc.text("TOTAL LIQUIDACIÓN", margin, yPos);
    doc.text(
      this.formatNum(liquidacion.LiqNeto, 2),
      pageWidth - margin - 5,
      yPos,
      { align: "right" },
    );
    yPos += 5;

    // Retención
    doc.setFont("helvetica", "normal");
    doc.text(
      `I.R.P.F. ${this.formatNum(liquidacion.LiqReten, 2)}% SOBRE ${this.formatNum(liquidacion.LiqBasReten, 2)}`,
      margin,
      yPos,
    );
    doc.text(
      this.formatNum(liquidacion.LiqImpReten * -1, 2),
      pageWidth - margin - 5,
      yPos,
      { align: "right" },
    );
    yPos += 5;

    // Bonificación (solo si existe)
    if (liquidacion.LiqImpBonif && liquidacion.LiqImpBonif !== 0) {
      doc.text("Importe bonificación", margin, yPos);
      doc.text(
        this.formatNum(liquidacion.LiqImpBonif * -1, 2),
        pageWidth - margin - 5,
        yPos,
        { align: "right" },
      );
      yPos += 5;
    }

    // Línea final
    doc.line(pageWidth - margin - anchoResumen, yPos, pageWidth - margin, yPos);
    yPos += 5;

    // Liquidación neta
    doc.setFont("helvetica", "bold");
    const liquidacionNeta =
      liquidacion.LiqNeto -
      liquidacion.LiqImpReten -
      (liquidacion.LiqImpBonif || 0);
    doc.text("LIQUIDACIÓN NETA", margin, yPos);
    doc.text(this.formatNum(liquidacionNeta, 2), pageWidth - margin - 5, yPos, {
      align: "right",
    });

    // Pie de página con número de página
    const totalPages = doc.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setFont("helvetica", "normal");
      doc.text(
        `- ${i} -`,
        pageWidth / 2,
        doc.internal.pageSize.getHeight() - 10,
        { align: "center" },
      );
    }
*/
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);

    const anchoResumen = 50;

    // Calcular altura del cuadro dinámicamente
    let numLineas = 5; // Base: subtotal, cargos, descuentos, APA
    if (liquidacion.NumPartidas > 1 || partidasLiq.length > 1) numLineas++;
    if (liquidacion.LiqPagado && liquidacion.LiqPagado !== 0) numLineas++;

    // Contar IVAs
    for (let i = 1; i <= 5; i++) {
      if (liquidacion[`LiqBases${i}`] && liquidacion[`LiqBases${i}`] !== 0)
        numLineas++;
    }

    numLineas += 2; // Total liquidación + IRPF
    if (liquidacion.LiqImpBonif && liquidacion.LiqImpBonif !== 0) numLineas++;
    numLineas++; // Liquidación neta

    const alturaResumen = numLineas * 5 + 10; // 5mm por línea + padding

    // Dibujar el rectángulo
    doc.setDrawColor(0);
    doc.setLineWidth(0.3);
    doc.rect(margin, yPos, contentWidth, alturaResumen);

    const inicioYResumen = yPos;
    yPos += 4; // Padding superior

    // Número de partidas (solo si hay más de 1)
    if (liquidacion.NumPartidas > 1 || partidasLiq.length > 1) {
      doc.text("Número de partidas", margin + 2, yPos);
      doc.text(
        String(liquidacion.NumPartidas || partidasLiq.length),
        pageWidth - margin - 7,
        yPos,
        { align: "right" },
      );
      yPos += 5;
    }

    // Subtotal liquidación
    doc.text("Subtotal liquidación", margin + 2, yPos);
    doc.text(
      this.formatNum(liquidacion.LiqCompra, 2),
      pageWidth - margin - 7,
      yPos,
      { align: "right" },
    );
    yPos += 5;

    // Importe cargos
    doc.text("Importe cargos", margin + 2, yPos);
    doc.text(
      this.formatNum(liquidacion.LiqImpCar, 2),
      pageWidth - margin - 7,
      yPos,
      { align: "right" },
    );
    yPos += 5;

    // Importe descuentos
    doc.text("Importe descuentos", margin + 2, yPos);
    doc.text(
      this.formatNum(liquidacion.LiqImpDto * -1, 2),
      pageWidth - margin - 7,
      yPos,
      { align: "right" },
    );
    yPos += 5;

    // Importe A.P.A.
    doc.text("Importe A.P.A.", margin + 2, yPos);
    doc.text(
      this.formatNum(liquidacion.LiqImpRappel * -1, 2),
      pageWidth - margin - 7,
      yPos,
      { align: "right" },
    );
    yPos += 5;

    // Anticipos (solo si existe)
    if (liquidacion.LiqPagado && liquidacion.LiqPagado !== 0) {
      doc.text("Importe anticipos", margin + 2, yPos);
      doc.text(
        this.formatNum(liquidacion.LiqPagado * -1, 2),
        pageWidth - margin - 7,
        yPos,
        { align: "right" },
      );
      yPos += 5;
    }

    // IVAs
    for (let i = 1; i <= 5; i++) {
      const base = liquidacion[`LiqBases${i}`];
      const iva = liquidacion[`LiqIVA${i}`];
      const cuota = liquidacion[`LiqCuiva${i}`];

      if (base && base !== 0) {
        doc.text(
          `I.V.A. ${this.formatNum(iva, 2)} % Sobre ${this.formatNum(base, 2)}`,
          margin + 2,
          yPos,
        );
        doc.text(this.formatNum(cuota, 2), pageWidth - margin - 7, yPos, {
          align: "right",
        });
        yPos += 5;
      }
    }

    // Línea antes del total (dentro del cuadro)
    doc.setLineWidth(0.1);
    doc.line(
      pageWidth - margin - anchoResumen - 5,
      yPos - 2,
      pageWidth - margin - 7,
      yPos - 2,
    );
    yPos += 3;

    // Total liquidación
    doc.setFont("helvetica", "bold");
    doc.text("TOTAL LIQUIDACIÓN", margin + 2, yPos);
    doc.text(
      this.formatNum(liquidacion.LiqNeto, 2),
      pageWidth - margin - 7,
      yPos,
      { align: "right" },
    );
    yPos += 5;

    // Retención
    doc.setFont("helvetica", "normal");
    doc.text(
      `I.R.P.F. ${this.formatNum(liquidacion.LiqReten, 2)}% SOBRE ${this.formatNum(liquidacion.LiqBasReten, 2)}`,
      margin + 2,
      yPos,
    );
    doc.text(
      this.formatNum(liquidacion.LiqImpReten * -1, 2),
      pageWidth - margin - 7,
      yPos,
      { align: "right" },
    );
    yPos += 5;

    // Bonificación (solo si existe)
    if (liquidacion.LiqImpBonif && liquidacion.LiqImpBonif !== 0) {
      doc.text("Importe bonificación", margin + 2, yPos);
      doc.text(
        this.formatNum(liquidacion.LiqImpBonif * -1, 2),
        pageWidth - margin - 7,
        yPos,
        { align: "right" },
      );
      yPos += 5;
    }

    // Línea final (dentro del cuadro)
    doc.line(
      pageWidth - margin - anchoResumen - 5,
      yPos - 2,
      pageWidth - margin - 7,
      yPos - 2,
    );
    yPos += 3;

    // Liquidación neta
    doc.setFont("helvetica", "bold");
    const liquidacionNeta =
      liquidacion.LiqNeto -
      liquidacion.LiqImpReten -
      (liquidacion.LiqImpBonif || 0);
    doc.text("LIQUIDACIÓN NETA", margin + 2, yPos);
    doc.text(this.formatNum(liquidacionNeta, 2), pageWidth - margin - 7, yPos, {
      align: "right",
    });

    yPos = inicioYResumen + alturaResumen + 5; // Posicionar después del cuadro

    // Pie de página con número de página
    const totalPages = doc.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setFont("helvetica", "normal");
      doc.text(
        `- ${i} -`,
        pageWidth / 2,
        doc.internal.pageSize.getHeight() - 10,
        { align: "center" },
      );
    }

    // Guardar PDF
    const nombreArchivo = `ImpLiquid_Soc${liquidacion.CliCodig}_${liquidacion.LiqNumer}.pdf`;
    //console.log("Guardando PDF como:", nombreArchivo);
    doc.save(nombreArchivo);
    //console.log("PDF guardado correctamente");
  }

  formatearFecha(fecha: any): string {
    if (!fecha) return "";
    const f = new Date(fecha);
    const dia = String(f.getDate()).padStart(2, "0");
    const mes = String(f.getMonth() + 1).padStart(2, "0");
    const anio = f.getFullYear();
    return `${dia}/${mes}/${anio}`;
  }

  formatNum(num: number, decimales: number = 2): string {
    if (num === null || num === undefined) return "0," + "0".repeat(decimales);
    return num.toFixed(decimales).replace(".", ",");
  }
}
